export const getChannels = async (
  welletContext,
  limit = 10,
  skip = 0,
  marketId = null,
  orgId = null,
  filter,
  dates = {
    from: null,
    to: null,
  },
  user = null,
  dateType = 'reservation',
  userId = [],
  rpId = [],
  showId = [],
  bossIds = [],
  orderBy = null,
  orderType = null,
  consumptionAmount = null,
  consumptionFilterEnum = [],
  reservationType = [],
  citiesIds = [],
  channelId = [],
  url = '/api/reservation/CHANNEL/LiveFeed',
) => {
  const body = {
    organizationId: marketId !== orgId ? orgId : null,
    marketSetupId: marketId,
    from: dates.from,
    to: dates.to,
    status: filter ? filter : [],
    limit,
    skip,
    filterField: user,
    dateType,
    userId,
    rpId,
    showId,
    bossIds: bossIds ? bossIds : [],
    sortBy: orderBy,
    columnFilter: orderType,
    consumptionAmount: consumptionAmount ? consumptionAmount : 0,
    consumptionFilterEnum: consumptionFilterEnum.length > 0 ? consumptionFilterEnum[0] : null,
    reservationType: reservationType.length > 0 ? reservationType : null,
    citiesIds: citiesIds ? citiesIds : [],
    channelId,
  };
  return await welletContext.apis.admin.post(url, body);
};

export const downloadChannels = async (welletContext, body) => {
  return await welletContext.apis.admin.post(`/api/ExcelReport/channel/reservations`, body, {
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getChannelsSimple = async (welletContext) => {
  return await welletContext.apis.admin.get(`/channel`);
};
